import React, { useState } from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  Box,
  Button
} from '@mui/material';
import { Link } from 'react-router-dom';

const CommonTable = ({ columns, data, renderActions, onAccordionOpen  }) => {
  const [openRow, setOpenRow] = useState(null);

  const toggleRow = (row) => {
    if (openRow === row.id) {
      setOpenRow(null);
    } else {
      setOpenRow(row.id);
      if (onAccordionOpen) {
        onAccordionOpen(row); 
      }
    }
  };
  return (
    <Table>
      <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
        <TableRow>
          {columns.map((col) => (
            <TableCell key={col.key}>{col.label}</TableCell>
          ))}
          {renderActions && <TableCell align="center">Actions</TableCell>}
        </TableRow>
      </TableHead>
      
      <TableBody>
        {data.map((row) => (
          <React.Fragment key={row.id}>
            <TableRow>
              {columns.map((col) => (
                <TableCell key={col.key} sx={{textWrap: "nowrap",}}>
                  {col.type === 'accordion' ? (
                    row[col.key]?.length > 0 ? (
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => toggleRow(row)}
                      >
                        {openRow === row.id ? 'Hide Contacts' : 'Show Contacts'}
                      </Button>
                    ) : (
                      'No Contacts'
                    )
                  ) : (
                    row[col.key]
                  )}
                </TableCell>
              ))}
              {renderActions && (
                <TableCell align="center" sx={{ display: 'flex', justifyContent: 'center' }}>
                  {renderActions(row)}
                </TableCell>
              )}
            </TableRow>

            {/* Accordion Content */}
            {openRow === row.id && (
              <TableRow>
                <TableCell colSpan={columns.length + 1}>
                  <Collapse in={openRow === row.id}>
                    <Box sx={{ margin: 2 }}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Contact Link</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {row.contacts.map((contact, index) => (
                            <TableRow key={index}>
                              <TableCell>
                                <Link to={contact.href} target="_blank">
                                  {contact.href}
                                </Link>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
            )}
          </React.Fragment>
        ))}
      </TableBody>
    </Table>
  );
};

export default CommonTable;
